// @flow
import * as React from 'react';
import {
  QueryClientProvider as BaseQueryClientProvider,
  QueryClient,
  type QueryClientConfig,
} from 'react-query';

export type Props = $ReadOnly<{|
  config?: ?QueryClientConfig,
  children?: React.Node,
|}>;

const QueryClientProvider = ({ config, children }: Props): React.Node => (
  <BaseQueryClientProvider client={new QueryClient(config || undefined)}>
    {children}
  </BaseQueryClientProvider>
);

export default QueryClientProvider;
